import styled from "styled-components";
import { getColor } from "../themeHandler";

interface ButtonProps {
  readonly backgroundColor?: string;
  readonly modalTheme: string;
  readonly confirmButtonSize: string;
}
export const StyledButton = styled.button<ButtonProps>`
  display: block;
  width: auto;
  min-width: ${(props) => handlerButtonSize(props.confirmButtonSize)};
  background-color: ${(props) => getColor(props.modalTheme, 'buttonBackgroundColor')};
  color: ${(props) => getColor(props.modalTheme, 'buttonTextColor')};
  text-align: center;
  padding: 0.8em 1em;
  border-radius: 4px;
  margin-top: 1.5em;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
  border: none;

  &:hover {
    color: ${(props) => getColor(props.modalTheme, 'buttonTextHoverColor')} !important;
  }
`;

const handlerButtonSize = (confirmButtonSize: string) => {
  switch (confirmButtonSize) {
    case "md":
      return "12em";

    case "lg":
      return "16em";
  }
};

StyledButton.defaultProps = {};
